var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15H3.75C2.925 15 2.25 15.675 2.25 16.5C2.25 17.325 2.925 18 3.75 18C2.925 18 2.25 18.675 2.25 19.5C2.25 20.325 2.925 21 3.75 21H18.75C20.4 21 21.75 19.65 21.75 18C21.75 16.35 20.4 15 18.75 15Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 17.25V18H3.75",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3H3.75C2.925 3 2.25 3.675 2.25 4.5C2.25 5.325 2.925 6 3.75 6C2.925 6 2.25 6.675 2.25 7.5C2.25 8.325 2.925 9 3.75 9H18.75C20.4 9 21.75 7.65 21.75 6C21.75 4.35 20.4 3 18.75 3Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 5.25V6H3.75",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9H20.25C21.075 9 21.75 9.675 21.75 10.5C21.75 11.325 21.075 12 20.25 12C21.075 12 21.75 12.675 21.75 13.5C21.75 14.325 21.075 15 20.25 15H5.25C3.6 15 2.25 13.65 2.25 12C2.25 10.35 3.6 9 5.25 9Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 11.25V12H20.25",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/clean.7c3c65beee73fea489848b86ee3bbbb8.svg";
export { ForwardRef as ReactComponent };